export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/ipad-2a52c8d80ae9860f6905e3638f759a01.png";